import React from 'react';
import { Modal } from 'react-bootstrap';

const BaseModal = ({ show, title, children, handleClose, size = "md" }) => {
  return (
    <Modal show={show} onHide={handleClose} size={size} centered >
      <Modal.Header closeButton style={{ margin: '0px', padding: '30px', paddingBottom: '0px' }}>
        <Modal.Title className="m-0 ms-0">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default BaseModal;